<div class="border-round-xl">
    <div class="flex mb-4 justify-content-between align-items-center" *ngIf="!hideCalendar">
        <!-- <p-dropdown
            [options]="monthsList"
            optionLabel="label"
            appendTo="body"
            (onChange)="fetchBillingCardData(selectedMonth1)"
            class="custom-dropdown-filter"
            [(ngModel)]="selectedMonth1"
            optionValue="label"
            placeholder="Select Month"
        >
        </p-dropdown> -->

        <div *ngIf="showOutstandingBox">
            <span class="outstanding-box">
                Total Outstanding: ${{ outstandingAmount | number : "1.2-2" }}
            </span>
        </div>
    </div>

    <!-- Show outstanding box when calendar is hidden -->
    <div class="flex mb-0 justify-content-end" *ngIf="hideCalendar && showOutstandingBox">
        <span
            class="outstanding-box outstanding-admin"
        >
            Total Outstanding: ${{ outstandingAmount | number : "1.2-2" }}
        </span>
    </div>

    <div class="summary-card"
         (click)="onCardClick('amountInvoiced')"
         [style.cursor]="hideCalendar ? 'pointer' : 'default'"
         [class.selected]="selectedCardType === 'amountInvoiced' || selectedCardType === 'AmountInvoiced'">
        <!-- Left Section -->
        <div class="label-section align-items-center">
            <span>Amount Invoiced</span> &nbsp; &nbsp;
            <!-- <div class="text-gradient">${{totalAmount}}</div> -->
            <div class="text-gradient">
                ${{ totalAmount | number : "1.2-2" }}
            </div>
        </div>

        <!-- Right Section -->
        <div class="bar-section">
            <!-- <div class="bar">
                <div class="paid"></div>
                <div class="progress"></div>
                <div class="outstanding"></div>
            </div> -->
            <div
                class="custom-progress-bar"
                style="
                    display: flex;
                    height: 20px;
                    border-radius: 8px;
                    overflow: hidden;
                    background: #F6F6F6;
                "
            >
                <div
                    *ngIf="netPaidProgressPercentage > 0"
                    [style.width.%]="netPaidProgressPercentage"
                    [style.backgroundColor]="netPaidColour"
                    style="height: 100%"
                ></div>
                <div
                    *ngIf="upcomingProgressPercentage > 0"
                    [style.width.%]="upcomingProgressPercentage"
                    [style.backgroundColor]="inProgressColor"
                    style="height: 100%"
                ></div>
                <div
                    *ngIf="remainingProgressPercentage > 0"
                    [style.width.%]="remainingProgressPercentage"
                    [style.backgroundColor]="outstandingColor"
                    style="height: 100%"
                ></div>
                <!-- <div
                    *ngIf="refundProgressPercentage > 0"
                    [style.width.%]="refundProgressPercentage"
                    [style.backgroundColor]="refundColor"
                    style="height: 100%"
                ></div> -->
            </div>
            <div class="legend mt-2">
                <div class="legend-item">
                    <span
                        class="circle"
                        [style.backgroundColor]="netPaidColour"
                    ></span>
                    Net Paid ({{ netPaidProgressPercentage }}%)
                </div>
                <div class="legend-item">
                    <span
                        class="circle"
                        [style.backgroundColor]="inProgressColor"
                    ></span>
                    In Process ({{ upcomingProgressPercentage }}%)
                </div>
                <div class="legend-item">
                    <span
                        class="circle"
                        [style.backgroundColor]="outstandingColor"
                    ></span>
                    Outstanding ({{ remainingProgressPercentage }}%)
                </div>
                <!-- <div class="legend-item">
                    <span
                        class="circle"
                        [style.backgroundColor]="refundColor"
                    ></span>
                    Refund ({{ refundProgressPercentage }}%)
                </div> -->
            </div>
        </div>
    </div>

    <div class="grid " style="display: flex; flex-wrap: nowrap; gap: 0.25rem;">
        <div class="col-12 md:col" style="flex: 1; min-width: 0;">
            <div class="surface-card p-2 border-1 surface-border border-round-xl"
                 (click)="onCardClick('netPaid')"
                 [style.cursor]="hideCalendar ? 'pointer' : 'default'"
                 [class.selected]="selectedCardType === 'netPaid' || selectedCardType === 'NetPaid'"
                >
                <div class="flex justify-content-between mb-2">
                    <span class="font-medium">Net Paid</span>
                    <!-- <span class="text-600 text-xs">{{selectedMonth1}} {{selectedYear}}</span> -->
                    <div
                        class="font-semibold text-sm text-right mt-2"
                        style="color: #ACF3AA"
                    >
                        {{ netPaidProgressPercentage }}%
                    </div>
                </div>
                <hr class="dashed-line" />
                <div class="text-2xl font-bold mb-1">
                    ${{ invoiceCount.netAmountPaid | number : "1.2-2" }}
                </div>
                <div
                    class="custom-progress-bar"
                    style="
                        display: flex;
                        height: 20px;
                        border-radius: 8px;
                        overflow: hidden;
                        background: #F6F6F6;
                    "
                    *ngIf="invoiceCount"
                >
                    <div
                        *ngIf="
                            invoiceCount.netAmountPaid &&
                            invoiceCount.netAmountPaid > 0
                        "
                        [style.width.%]="netPaidProgressPercentage"
                        [style.backgroundColor]="netPaidColour"
                        style="height: 100%"
                    ></div>
                </div>
            </div>
        </div>

        <div class="col-12 md:col" style="flex: 1; min-width: 0;">
            <div class="surface-card p-2 border-1 surface-border border-round-xl"
                (click)="onCardClick('inProgress')"
                [style.cursor]="hideCalendar ? 'pointer' : 'default'"
                [class.selected]="selectedCardType === 'inProgress' || selectedCardType === 'In-Process'"
                >
                <div class="flex justify-content-between mb-2">
                    <span class="font-medium">In Process</span>
                    <!-- <span class="text-600 text-xs">{{selectedMonth1}} {{selectedYear}}</span> -->
                    <div
                        class="font-semibold text-sm text-right mt-2"
                        style="color: #ff9616"
                    >
                        {{ upcomingProgressPercentage }}%
                    </div>
                </div>
                <hr class="dashed-line" />
                <div class="text-2xl font-bold mb-1">
                    ${{ invoiceCount.amountInProcess | number : "1.2-2" }}
                </div>
                <div
                    class="custom-progress-bar"
                    style="
                        display: flex;
                        height: 20px;
                        border-radius: 8px;
                        overflow: hidden;
                        background: #F6F6F6;
                    "
                    *ngIf="invoiceCount"
                >
                    <div
                        *ngIf="
                            invoiceCount.amountInProcess &&
                            invoiceCount.amountInProcess > 0
                        "
                        [style.width.%]="upcomingProgressPercentage"
                        [style.backgroundColor]="inProgressColor"
                        style="height: 100%"
                    ></div>
                </div>
            </div>
        </div>

        <div class="col-12 md:col" style="flex: 1; min-width: 0;">
            <div class="surface-card p-2 border-1 surface-border border-round-xl"
                (click)="onCardClick('outstanding')"
                [style.cursor]="hideCalendar ? 'pointer' : 'default'"
                [class.selected]="selectedCardType === 'outstanding' || selectedCardType === 'Outstanding'"
                >
                <div class="flex justify-content-between mb-2">
                    <span class="font-medium">Outstanding</span>
                    <!-- <span class="text-600 text-xs">{{selectedMonth1}} {{selectedYear}}</span> -->
                    <div
                        class="font-semibold text-sm text-right mt-2"
                        style="color: #e35246"
                    >
                        {{ remainingProgressPercentage }}%
                    </div>
                </div>
                <hr class="dashed-line" />
                <div class="text-2xl font-bold mb-1">
                    ${{ invoiceCount.amountUnpaid | number : "1.2-2" }}
                </div>
                <div
                    class="custom-progress-bar"
                    style="
                        display: flex;
                        height: 20px;
                        border-radius: 8px;
                        overflow: hidden;
                        background: #F6F6F6;
                    "
                    *ngIf="invoiceCount"
                >
                    <div
                        *ngIf="
                            invoiceCount.amountUnpaid &&
                            invoiceCount.amountUnpaid > 0
                        "
                        [style.width.%]="remainingProgressPercentage"
                        [style.backgroundColor]="outstandingColor"
                        style="height: 100%"
                    ></div>
                </div>
            </div>
        </div>

        <div class="col-12 md:col" style="flex: 1; min-width: 0;">
            <div class="surface-card p-2 border-1 surface-border border-round-xl"
            (click)="onCardClick('refund')"
            [style.cursor]="hideCalendar ? 'pointer' : 'default'"
            [class.selected]="selectedCardType === 'refund' || selectedCardType === 'Refund'"
            >
                <div class="flex justify-content-between mb-2">
                    <span class="font-medium">Refund</span>
                    <!-- <span class="text-600 text-xs">{{selectedMonth1}} {{selectedYear}}</span> -->
                    <div
                        class="font-semibold text-sm text-right mt-2"
                        style="color: #3b82f6"
                    >
                    
                    </div>
                </div>
                <hr class="dashed-line" />
                <div class="text-2xl font-bold mb-1">
                    ${{ invoiceCount.amountRefund | number : "1.2-2" }}
                </div>
                <div
                    class="custom-progress-bar"
                    style="
                        display: flex;
                        height: 20px;
                        border-radius: 8px;
                        overflow: hidden;
                        background: #F6F6F6;
                    "
                    *ngIf="invoiceCount"
                >
                    <div
                        *ngIf="
                            invoiceCount.amountRefund &&
                            invoiceCount.amountRefund > 0
                        "
                        [style.width.%]="refundProgressPercentage"
                        [style.backgroundColor]="refundColor"
                        style="height: 100%"
                    ></div>
                </div>
            </div>
        </div>

         <div class="col-12 md:col" style="flex: 1; min-width: 0;">
            <div class="surface-card p-2 border-1 surface-border border-round-xl"
                (click)="onCardClick('paid')"
                [style.cursor]="hideCalendar ? 'pointer' : 'default'"
                [class.selected]="selectedCardType === 'paid' || selectedCardType === 'Paid'"
                >
                <div class="flex justify-content-between mb-2">
                    <span class="font-medium">Paid</span>
                    <div
                        class="font-semibold text-sm text-right mt-2"
                        style="color: #25ac7c"
                    >
                       
                    </div>
                </div>
                <hr class="dashed-line" />
                <div class="text-2xl font-bold mb-1">
                    ${{ invoiceCount.amountPaid | number : "1.2-2" }}
                </div>
                <div
                    class="custom-progress-bar"
                    style="
                        display: flex;
                        height: 20px;
                        border-radius: 8px;
                        overflow: hidden;
                        background: #F6F6F6;
                    "
                    *ngIf="invoiceCount"
                >
                    <div
                        *ngIf="
                            invoiceCount.amountPaid &&
                            invoiceCount.amountPaid > 0
                        "
                        [style.width.%]="activeProgressPercentage"
                        [style.backgroundColor]="'#25ac7c'"
                        style="height: 100%"
                    ></div>
                </div>
            </div>
        </div>

    </div>
</div>
